import moment from "moment";
import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import Select from "react-select";
import appointmentBW from "../../Assets/Images/appointmentBW.png";
import Widgets from "../../Widgets/index";
import "./RequestAppointment.css";
import utils from "../../Utils/index";
import { t } from "../../Utils/translate";
import ApproveAppointmentDetail from "../../Widgets/ApproveAppointment/ApproveApointmentDetail1";
import clinicService from "../../Services/clinicService";
import authService from "../../Services/authService";
import { hospitalAppointment } from "../../Services/clinicService";
import { useSelector } from "react-redux";

function RequestAppointment() {
  const state = useLocation();
  const isRefresh = useSelector((state) => state.refreshNoti.refreshNoti);
  const [date, setDate] = useState(moment(new Date()).format("YYYY-MM-DD"));
  const [topHeight, setTopHeight] = useState(0);
  const [selectedAppointmentIndex, setSelectedAppointmentIndex] = useState(null);
  const [selectedDoctor, setSelectedDoctor] = useState(null); // State to track selected doctor
  const [reqCardType, setreqCardType] = useState("ACTIVE");
  const [appointments, setAppointments] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [userNameErr, setUserNameErr] = useState("");
  const [doctorDetails, setDoctorDetails] = useState([]);
  const [doctorOptions, setDoctorOptions] = useState([]);
  const isDoctorListFetched = useRef(false);
  const [isDoctorLogin, setIsDoctorLogin] = useState(false);
  const [doctorCount, setDoctorCount] = useState([]);
  const [hospitalCount, setHospitalCount] = useState([]);
  const [showTab, setShowTab] = useState(true);
  const [mobileView, setMobileView] = useState(false);
    const {doctorId, appointmentId, startTime, appointmentDate, type } = state.state || {};
      const [selectedSlot, setSelectedSlot] = useState("ACTIVE");
    // console.log(doctorId,appointmentId, startTime,appointmentDate, type)
    // console.log(doctorId,appointmentId, startTime,appointmentDate, type)

 useEffect(() => {
  const isInactive = type === "CANCELLED" || type === "REJECTED";
  setSelectedSlot(isInactive ? "INACTIVE" : "ACTIVE");
}, [type, selectedDoctor]);

useEffect(() => {
  if (selectedSlot && selectedDoctor) {
    refreshAppointments();
  }
}, [selectedSlot, selectedDoctor]);


  // const runRefresh = async () => {
  //   await refreshAppointments();
  // };

  useEffect(() => {
    setIsDoctorLogin(authService.getIsDoctorLogin() === "true");
    const handleResize = () => {
      if (window.innerWidth <= 768) {
        setMobileView(true);
        setShowTab(false);
      } else {
        setMobileView(false);
      }
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  useEffect(() => {
        // const newDate = moment(state?.state?.date).format("YYYY-MM-DD");
  const newDate = moment(appointmentDate || new Date()).format("YYYY-MM-DD");
  setDate(newDate);
    if (doctorOptions && doctorOptions.length > 0 && state.state) {
      const selectedDoc = doctorOptions.find((doctor) => doctor.value === state.state.doctorId);
      setSelectedDoctor(selectedDoc?.value);
      setDate(newDate);
      fetchAppointmentsByDoctor(selectedDoctor, selectedSlot, newDate);
    }
    if (doctorOptions && doctorOptions.length > 0 && state.state) {
      setSelectedAppointmentIndex(state.state.appointmentId);
    }

    if (authService.getIsDoctorLogin() === "true" && state.state) {
      setSelectedAppointmentIndex(state.state.appointmentId);
      setDate(newDate);
      fetchAppointmentsByDoctor(selectedDoctor, selectedSlot, newDate);
    }
  }, [doctorOptions, appointmentDate, type]);

  useEffect(() => {
    if (!isDoctorListFetched.current) {
      // Check if fetch has already been done
      const fetchDoctorList = async () => {
        try {
          setIsLoading(true);
          let response;
          if (authService.getIsDoctorLogin() === "false") {
            response = await clinicService.getDoctorList();
          }
          setIsLoading(false);
          if (response && response.status) {
            const doctorDetails = response.data.doctors;
            const doctorOptions = doctorDetails?.filter((doctor) => doctor.isActive).map((doctor) => ({
              value: doctor._id,
              label: doctor.name,
            }));
            setDoctorOptions(doctorOptions);

            // Automatically select the first doctor by default and fetch its appointments
            if (doctorOptions.length > 0 && !state.state) {
              setSelectedDoctor(doctorOptions[0].value);
              await fetchAppointmentsByDoctor(doctorOptions[0].value, selectedSlot);
            }
          }
        } catch (error) {
          setIsLoading(false);
        }
      };
      fetchDoctorList(); // Call fetchDoctorList only once
      isDoctorListFetched.current = true; // Set the flag to prevent future calls
    }

    if (authService.getIsDoctorLogin() === "true") {
      setIsDoctorLogin(true);
    } else if (authService.getIsDoctorLogin() === "false") {
      setIsDoctorLogin(false);
    }
  }, []);
  const handleDoctorChange = async (selectedOption) => {
    setSelectedDoctor(selectedOption.value, selectedSlot);
    await refreshAppointments(selectedOption.value);
  };

  useEffect(() => {
    if (authService.getIsDoctorLogin() === "false") {
      refreshAppointments();
    }
  }, [selectedDoctor]);

  useEffect(() => {
    if (authService.getIsDoctorLogin() === "true" && !state.state && appointments.length === 0) {
      refreshAppointments();
    }
  }, []);

  const selectedAppointment = appointments.find((appointment) => appointment._id === selectedAppointmentIndex);

  const fetchAppointmentsByDoctor = async (doctorId, status, newDate, load) => {
    const apiParams = {
      ACTIVE: ["WAITING_FOR_CLINIC_CONFIRMATION", "CONFIRMED"],
      INACTIVE: ["CANCELLED", "REJECTED", "EXPIRED"],
    };

    const requestBody = {
      date: newDate || date || new Date().toISOString().split("T")[0],
      statuses: apiParams[status],
      doctor: doctorId || "",
    };

    const docBody = {
      date: newDate || date || new Date().toISOString().split("T")[0],
      statuses: apiParams[status],
    };

    const jwtToken = localStorage.getItem("FV_sessionToken");

    try {
      if(load !== "load"){
        setIsLoading(true);
      }
      let apiResponse;
      if (authService.getIsDoctorLogin() === "true") {
        apiResponse = await clinicService.docGetAllAppointment(docBody);
        // setDoctorCount(apiResponse.data.totalDocuments)
        if (selectedSlot === "ACTIVE") {
          const waitingForClinicConfirmationCount = apiResponse.data.appointments.filter((appointment) => appointment.status === "WAITING_FOR_CLINIC_CONFIRMATION").length;
          setHospitalCount(waitingForClinicConfirmationCount);
        }
        if (selectedSlot === "INACTIVE") {
          setHospitalCount(apiResponse?.data?.totalDocuments);
        }
        setAppointments(apiResponse.data.appointments);
        if (apiResponse.data.appointments.length > 0) {
          if (!state.state) {
            setSelectedAppointmentIndex(apiResponse.data.appointments[0]._id);
          } else {
            const selectedAppointment = apiResponse.data.appointments.find((appointment) => appointment._id === state.state.appointmentId);
            if (!selectedAppointment) {
              setSelectedAppointmentIndex(apiResponse.data.appointments[0]._id);
            } else {
              setSelectedAppointmentIndex(selectedAppointment._id);
            }
          }
        }
      } else if (authService.getIsDoctorLogin() === "false") {
        apiResponse = await hospitalAppointment(requestBody, jwtToken);
        if (selectedSlot === "ACTIVE") {
          const waitingForClinicConfirmationCount = apiResponse.appointments.filter((appointment) => appointment.status === "WAITING_FOR_CLINIC_CONFIRMATION").length;
          setHospitalCount(waitingForClinicConfirmationCount);
        }
        if (selectedSlot === "INACTIVE") {
          setHospitalCount(apiResponse?.totalDocuments);
        }
        if (apiResponse) {
          setAppointments(apiResponse.appointments);
          if (apiResponse.appointments.length > 0) {
            if (!state.state) {
              setSelectedAppointmentIndex(apiResponse.appointments[0]._id);
            } else {
              const selectedAppointment = apiResponse.appointments.find((appointment) => appointment._id === state.state.appointmentId);
              if (!selectedAppointment) {
                setSelectedAppointmentIndex(apiResponse.appointments[0]._id);
              } else {
                setSelectedAppointmentIndex(selectedAppointment._id);
              }
            }
          }
        }
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      // console.error("Error fetching appointments by doctor:", error.message);
    }
  };

    useEffect(() => {
      if(selectedDoctor){
        fetchAppointmentsByDoctor(selectedDoctor, selectedSlot, undefined, "load");
      }
    }, [isRefresh]);

  const handleCardState = async (selectedOption) => {
    const selectedValue = selectedOption?.value;
    await refreshAppointments();
    setSelectedSlot(selectedValue); // Update the selected slot state

    // Only fetch appointments if a doctor is selected
    if (selectedDoctor) {
      await fetchAppointmentsByDoctor(selectedDoctor, selectedValue);
    }
    if (isDoctorLogin) {
      await fetchAppointmentsByDoctor(selectedDoctor, selectedValue);
    }
  };

  //fetching doctor name

  const handleCardClick = (index) => {
    setSelectedAppointmentIndex(index);
    setShowTab(true);
  };
  function getAgeFromDateOfBirth(patientAge) {
    return moment().diff(patientAge, "years");
  }
  const handleSlotChange = (slot) => {
    setSelectedSlot(slot.value);
  };
  // const handleDateChange = (date) => {
  //   refreshAppointments();
  //   setDate(date);
  //   // Fetch appointments based on the selected date, doctor, and status
  // };
  const handleDateChange = (newDate) => {
    setDate(newDate);
    fetchAppointmentsByDoctor(selectedDoctor, selectedSlot, newDate);
    // Removed the API call from here
  };

  const refreshAppointments = async () => {
    if (selectedDoctor && selectedSlot) {
      await fetchAppointmentsByDoctor(selectedDoctor, selectedSlot);
    }
    if (authService.getIsDoctorLogin() === "true") {
      console.log("first", selectedDoctor, selectedSlot);
      await fetchAppointmentsByDoctor(selectedDoctor, selectedSlot);
    }
  };
  // console.log(selectedSlot,"slot")
  return (
    <React.Fragment>
      {isLoading ? <Widgets.CircularLoader /> : ""}
      <div className="screen-name p-3">
        <span style={{ marginRight: "5px" }}>{t("appointmentRequests")}</span>
        {doctorCount > 0 ? `(${doctorCount})` : hospitalCount > 0 ? `(${hospitalCount})` : null}
      </div>
      <div className="appointment-parent px-3 ">
        {/* {authService.getIsDoctorLogin() == "false" && <FloatingScanner />} */}
        <div className="appointment-parent-col appointment-parent-col-1">
          <div className="app-section-left">
            <div className="appointment-view-parent">
              <Widgets.AppointmentCalender
                className="box1"
                styles={{
                  height: topHeight + "px",
                }}
                // onselect={(date) => {
                //   setDate(date);
                // }}
                onselect={handleDateChange}
                setTopHeight={(height) => {
                  setTopHeight(height);
                }}
                value={date}
              />

              <div className="appointment-view box2 appointment-view-height">
                <div className="appointment-card-filter-view">
                  <div className="appointment-card-filter-view-col-1 appointment-card-filter-view-approved-appointment-adjust filter">
                    {!isDoctorLogin && (
                      <div className="appointment-card-filter-view-col-1-2">
                        <Select
                          isSearchable={true}
                          className="me-1"
                          styles={utils.appStyles.appointmentDropDown}
                          options={doctorOptions}
                          value={doctorOptions.find((option) => option.value === selectedDoctor) || null}
                          onChange={handleDoctorChange} // Update appointments when doctor changes
                        />
                      </div>
                    )}
                    <div>
                      <div className={"refresh-appointment-list-icon-parent"}>
                        <i
                          id="refresh-appointment"
                          className="ri-refresh-line refresh-appointment-list-icon"
                          onClick={
                            refreshAppointments
                            // rotateRefreshIcon();
                            // getAppointmentList();
                          }
                        />
                      </div>
                    </div>

                    {!isDoctorLogin ? (
                      <div className="appointment-card-filter-view-col-2" style={{ width: "150px" }}>
                        <Select
                          value={utils.constants.requestAppointmentStateList.find((option) => option.value === selectedSlot)} // Find the selected option
                          isSearchable={false}
                          className="me-1"
                          styles={utils.appStyles.appointmentDropDown}
                          options={utils.constants.requestAppointmentStateList}
                          onChange={handleCardState} // Fetch appointments based on selected state
                        />
                      </div>
                    ) : (
                      <div className="appointment-card-filter-view-col-2" style={{ width: "150px" }}>
                        <Select
                          value={utils.constants.requestAppointmentStateList.find((option) => option.value === selectedSlot)} // Find the selected option
                          isSearchable={false}
                          className="me-1"
                          styles={utils.appStyles.appointmentDropDown}
                          options={utils.constants.requestAppointmentStateList}
                          onChange={handleCardState} // Fetch appointments based on selected state
                        />
                      </div>
                    )}
                  </div>
                </div>
                <Widgets.AppointmentComponent
                  appointment={appointments}
                  selectedAppointmentIndex={selectedAppointmentIndex}
                  handleCardClick={handleCardClick}
                  specificDate={date}
                  selectedSlot={selectedSlot}
                  selectedDoctor={selectedDoctor}
                  refreshAppointments={refreshAppointments}
                  setSelectedAppointmentIndex={setSelectedAppointmentIndex}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="appointment-parent-col appointment-parent-col-2">
          <div>
            {selectedAppointmentIndex !== null ? (
              <ApproveAppointmentDetail appointment={selectedAppointment} showTab={showTab} setShowTab={setShowTab} />
            ) : (
              <div className="appointment-section-right-placeholder">
                <div className="appointment-details d-flex justify-content-between">
                  <div></div>
                  <div className="text-center">{t("appointmentDetails")}</div>
                  <div></div>
                </div>

                <div className="appointment-details-container p-3 bg-white d-flex justify-content-center ">
                  <div className="d-flex justify-content-center align-items-center">
                    <img className="no-appointments-image" src={appointmentBW} alt="noappointment" />
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </React.Fragment>
  );
}

export default RequestAppointment;
